import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  export(e) {
    e.preventDefault();
    var downloadUrl = this.data.get("url");
    console.log(downloadUrl);

    bootbox.prompt({
      className: "modal-md",
      size: "small",
      title: "Download invoice itemisation",
      message: "<p>Please select the type you want to download:</p>",
      inputType: "radio",
      buttons: {
        confirm: {
          label: "Download",
          className: "btn-success"
        },
        cancel: {
          label: "Cancel",
          className: "btn-standard"
        }
      },
      inputOptions: [
        {
          text: "Usage",
          value: "usage"
        },
        {
          text: "Charges",
          value: "charges"
        }
      ],
      callback: function (result) {
        console.log(downloadUrl);
        if (result) {
          window.location.href = `${downloadUrl}?type=${result}`;
          showNotification(
            "success",
            `Invoice ${result} itemisation has been downloaded`
          );
        }
      }
    });
  }
}
